import { SwaggerApiService } from './SwaggerApiService.service';
import { SwaggerApiRequestHeaders } from './SwaggerApiService.service';
import { eitherify, mapLeft, mapRight } from '@dev-stream/utils';
import { Inject, Optional, Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { BASE_URL, BusinessServerApiRootModule } from './BusinessServerApi.module';
import { OdataModel } from '@idocs-kz/swagger-schemas';
import { OdataPrimitive } from '@idocs-kz/swagger-schemas';
import { BillingPaymentVM } from '../models/BillingPaymentVM.model';

@Injectable({ providedIn: BusinessServerApiRootModule })
export class BillingPaymentApiService extends SwaggerApiService {
    public constructor(http: HttpClient, @Optional() @Inject(BASE_URL) baseUrl: string) {
        super(http, baseUrl);
    }

    public Get_by$select_by$expand_by$filter_by$orderby_by$top_by$skip_by$count<T extends OdataModel<BillingPaymentVM>>(
        queryParams: IGet_by$select_by$expand_by$filter_by$orderby_by$top_by$skip_by$count_Params,
        requestHeaders?: SwaggerApiRequestHeaders
    ) {
        const params = this.$MapParams(queryParams);
        const response = this.http.request<T>('get', `${this.baseUrl}/api/v2/reference/billing-payments`, {
            headers: requestHeaders,
            params,
            responseType: 'json',
        });

        return response.pipe(
            eitherify(),
            mapRight((response) => new OdataModel<BillingPaymentVM>(BillingPaymentVM, response)),
            mapLeft((ex) => (ex instanceof HttpErrorResponse ? ex : ex))
        );
    }
}

interface IGet_by$select_by$expand_by$filter_by$orderby_by$top_by$skip_by$count_Params {
    $select?: string | null;
    $expand?: string | null;
    $filter?: string | null;
    $orderby?: string | null;
    $top?: number | null;
    $skip?: number | null;
    $count?: boolean | null;
}
